import { render, staticRenderFns } from "./ClassEdit.vue?vue&type=template&id=8a39f582&"
import script from "./ClassEdit.vue?vue&type=script&lang=ts&"
export * from "./ClassEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports